import { Injectable } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import _ from 'lodash';
import { RRule, RRuleSet, Weekday } from 'rrule';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CreateRouteService {
  routesAPi = {
    recurringRoute: this._dataCollectorService.baseurl() + '/routes/recurring'
  };

  routeMapData: Subject<any> = new Subject<any>();

  constructor(
    private _dataCollectorService: DataCollectorService,
    private utilityService: UtilityService
  ) { }

  public getDistanceBetweenJobs(payload: any): Observable<any> {
    const distanceBetweenJobsUrl = `${this._dataCollectorService.baseurl()}/location/dispatch_board/routing`;
    return this._dataCollectorService.postData(distanceBetweenJobsUrl, payload).pipe(map((res: any)=>res));
  };

  public getRecurringRouteConflicts(payload: any): Observable<any> {
    window['urlState'] = 'conflicts';
    const routeConflictsUrl = `${this._dataCollectorService.baseurl()}/routes/recurring/conflicts`;
    return this._dataCollectorService.postData(routeConflictsUrl, payload).pipe(map((res: any)=>res));
  };

  generateRecurrenceRule(recurrenceValue: string, startDate: any, endValue: any, until: string, customValue?: any): any {
    const rruleOptions: any = {};
    const selectedDay = moment.utc(startDate).day() - 1;

    switch (recurrenceValue) {
      case 'DAILY':
        rruleOptions.freq = RRule.DAILY;
        break;
      case 'WEEKLY':
        rruleOptions.freq = RRule.WEEKLY;
        rruleOptions.byweekday = new Weekday(selectedDay < 0 ? 6 : selectedDay);
        break;
      case 'MONTHLY':
        rruleOptions.freq = RRule.MONTHLY;
        rruleOptions.bymonthday = moment.utc(startDate).date();
        break;
      case 'MONTHLY-ORDINAL-WEEK':
        const targetDate = moment(startDate);
        const startDateOfMonth = moment(targetDate).startOf('month');
        const weekCount = targetDate.diff(startDateOfMonth, 'week');
        rruleOptions.byweekday = new Weekday(selectedDay < 0 ? 6 : selectedDay, weekCount + 1);
        rruleOptions.freq = RRule.MONTHLY;
        break;
      case 'YEARLY':
        rruleOptions.freq = RRule.YEARLY;
        rruleOptions.bymonth = moment.utc(startDate).month() + 1;
        rruleOptions.bymonthday = moment.utc(startDate).date();
        break;
      case 'CUSTOM':
        rruleOptions.freq = customValue.type === 'WEEKS' ? RRule.WEEKLY : RRule.MONTHLY;
        const byWeekday = [];
        if(customValue?.module !== 'schedule'){
        customValue.days.map((week, weekIndex) => {
          week.week.map((item, dayIndex) => {
            if (item.value && customValue.type === 'WEEKS') {
              byWeekday.push(new Weekday(dayIndex));
            }
            let weekValue = weekIndex + 1;
            weekValue = weekValue === 5 ? -1 : weekValue;
            if (item.value && customValue.type === 'MONTHS') {
              byWeekday.push(new Weekday(dayIndex, weekValue));
            }
          });
        });
        rruleOptions.byweekday = byWeekday;
        rruleOptions.interval = Number(customValue.count);
      }
      else{
          customValue.days.map((week, weekIndex) => {
            let weekValue = weekIndex + 1;
            weekValue = weekValue === 5 ? -1 : weekValue;
            if(customValue.type === 'WEEKS'){
            week?.week?.map((item, dayIndex) => {
              if (item.value && customValue.type === 'WEEKS') {
                byWeekday.push(new Weekday(dayIndex));
              }
              if (item.value && customValue.type === 'MONTHS') {
                byWeekday.push(new Weekday(dayIndex, weekValue));
              }
            });
          }
          else if (customValue.type === 'MONTHS') {
            // Handle monthly recurrence
            week?.daysOfMonth?.map((item, dayIndex) => {
                if (item.value) {
                    rruleOptions.bymonthday = rruleOptions.bymonthday || [];
                    if (dayIndex + 1 === 32) {
                        rruleOptions.bymonthday.push(-1);
                    } else {
                        rruleOptions.bymonthday.push(dayIndex + 1);
                    }
                }
            });
        }
          });
          rruleOptions.byweekday = byWeekday;
          rruleOptions.interval = Number(customValue.count);
        }
        break;
    }

    const recurrenceStart = moment.utc(startDate);
    rruleOptions.dtstart = recurrenceStart.clone().toDate();

    if (until === 'date') {
      const recurrenceEnd = moment.utc(endValue).clone();
      recurrenceEnd.hours(recurrenceStart.hours()).minutes(recurrenceStart.minutes()).seconds(recurrenceStart.seconds()).milliseconds(recurrenceStart.milliseconds());
      rruleOptions.until = recurrenceEnd.toDate();
    }
    else {
      rruleOptions.count = endValue;
      const rruleDates = new RRule(rruleOptions)?.all();
      rruleOptions.until = moment(rruleDates[rruleDates?.length - 1]).toDate();
      delete rruleOptions.count;
    }
    return rruleOptions;
  }

getAddressText(address: any): string {
    return _.compact([address?.street, address?.landmark, address?.city || address?.name, address?.state, address?.zipcode || address?.zip_code, address?.country?.label || (_.isString(address?.country) ? address?.country : '')]).join(', ');
  }
}
